import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../services/loader/loader.service';
import { finalize } from 'rxjs/operators';

@Injectable()
export class loaderInterceptor implements HttpInterceptor  {
  constructor(private loaderService: LoaderService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
  const skipLoader = request.url.toLowerCase().includes('/notification');

    if (skipLoader) {
      this.loaderService.hide();
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!skipLoader) {
          this.loaderService.show();
        }
      })
    );
  }
};
